<template>
  <div class="pa-4 comparativo-configuracion-wrapper">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-4">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-card class="modern-report-card elevation-2 mb-4">
        <!-- Header moderno con gradiente y botón de ayuda (Estilo ReportePerdidasScrap) -->
        <div class="report-header-banner">
          <div class="d-flex align-center header-main-info">
            <div class="header-icon-box mr-3 flex-shrink-0">
              <v-icon color="white">mdi-scale-balance</v-icon>
            </div>
            <div class="header-text-block">
              <div class="font-weight-bold white--text header-company-title">
                Comparativo por Configuración
              </div>
              <div class="header-report-subtitle">
                Análisis comparativo de rendimiento, costos y proyección de
                neumáticos según configuración
              </div>
            </div>
          </div>

          <div
            class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
          >
            <!-- Chip resumen en cabecera si hay neumáticos asignados -->
            <v-chip
              v-if="cantidadNeumaticosAsignados > 0"
              small
              class="d-none d-sm-inline-flex mr-2 summary-header-chip"
            >
              <v-icon left x-small color="amber lighten-2">mdi-tire</v-icon>
              Comparando: <strong>{{ cantidadNeumaticosAsignados }}/5</strong>
            </v-chip>

            <!-- Botón de ayuda -->
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="
                    global && global.helpdesk_url
                      ? global.helpdesk_url +
                        'reporte-comparativo-configuracion'
                      : '#'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="22" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Cuerpo del Reporte -->
        <v-card-text class="pa-4 pa-md-5">
          <!-- 1. Card de Filtros de Búsqueda -->
          <v-card
            class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-5"
          >
            <div
              class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2"
                  >mdi-filter-variant</v-icon
                >
                <span
                  class="font-weight-bold text-caption text-uppercase text--primary"
                >
                  Filtros de Búsqueda de Neumáticos
                </span>
              </div>
            </div>

            <div class="pa-4 pa-md-5">
              <!-- Fila 1: Marca, Modelo, Medida, Tipo de costo -->
              <v-row align="center">
                <!-- Marca -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="Marcas"
                    v-model="Item.marca"
                    label="Marca"
                    placeholder="Todas las marcas"
                    clearable
                    prepend-inner-icon="mdi-tag-outline"
                    class="field-custom"
                    @change="onMarca"
                  ></v-autocomplete>
                </v-col>

                <!-- Modelo -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="modelosPorMarca"
                    v-model="Item.modelo"
                    label="Modelo"
                    placeholder="Todos los modelos"
                    clearable
                    prepend-inner-icon="mdi-car-info"
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>

                <!-- Medida -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="Medidas"
                    v-model="Item.medida"
                    label="Medida"
                    placeholder="Todas las medidas"
                    clearable
                    prepend-inner-icon="mdi-ruler"
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>

                <!-- Tipo de costo -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="tiposCosto"
                    v-model="Item.tipocosto"
                    label="Tipo de costo"
                    placeholder="Kilómetros u Horas"
                    clearable
                    prepend-inner-icon="mdi-currency-usd"
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>
                <!-- Eje -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="ejes"
                    v-model="Item.eje"
                    label="Eje"
                    placeholder="Todos los ejes"
                    clearable
                    prepend-inner-icon="mdi-car-traction-control"
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>

                <!-- Condición -->
                <v-col cols="12" sm="6" md="4" lg="4">
                  <v-autocomplete
                    outlined
                    dense
                    hide-details="auto"
                    :items="reencauches"
                    v-model="Item.condicion"
                    label="Condición del neumático"
                    placeholder="Todas las condiciones"
                    clearable
                    prepend-inner-icon="mdi-tire"
                    class="field-custom"
                  ></v-autocomplete>
                </v-col>

                <!-- Botón Filtrar -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  offset-sm="6"
                  offset-md="8"
                  offset-lg="8"
                  class="d-flex align-center"
                >
                  <v-btn
                    color="primary"
                    block
                    height="40"
                    class="filter-action-btn font-weight-bold"
                    :disabled="loader"
                    :loading="loader"
                    @click="cargarDatos"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Filtrar Neumáticos
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>

          <!-- 2. Catálogo de Neumáticos Disponibles (Componente Neumaticos) -->
          <div class="mb-5">
            <Neumaticos
              tipo="configuracion"
              :Items="Items"
              :data="data"
              :per_page="per_page"
              :loader="loader"
              :from="from"
              :to="to"
              :page="page"
              :ItemTotal="ItemTotal"
              :VerTooltip="VerTooltip"
              :dato_seleccionado="dato_seleccionado"
              :seleccionados="seleccionados"
              @getListado="FiltroNeumaticos"
              @seleccionarNeumatico="seleccionarNeumatico"
            >
            </Neumaticos>
          </div>

          <!-- 3. Card de Tabla de Comparación de Neumáticos -->
          <v-card
            class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mt-4"
          >
            <div
              class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
            >
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2"
                  >mdi-scale-balance</v-icon
                >
                <span
                  class="font-weight-bold text-caption text-uppercase text--primary"
                >
                  Tabla de Comparación de Neumáticos
                </span>
              </div>

              <div class="d-flex align-center">
                <v-chip
                  x-small
                  color="primary lighten-4"
                  class="primary--text font-weight-bold mr-2"
                >
                  <v-icon left x-small>mdi-compare</v-icon>
                  {{ cantidadNeumaticosAsignados }} / 5 asignados
                </v-chip>

                <v-btn
                  v-if="mostrarComponente == true"
                  color="success"
                  x-small
                  height="28"
                  class="font-weight-bold text-none px-3"
                  :loading="loadingExcel"
                  :disabled="!NeumaticosAComparar.some((e) => e.id)"
                  @click="exportarAExcel"
                >
                  <v-icon left x-small>mdi-file-excel</v-icon>
                  Exportar Excel
                </v-btn>
              </div>
            </div>

            <div class="pa-4">
              <!-- Alerta informativa -->
              <v-alert
                dense
                text
                color="info"
                icon="mdi-information-outline"
                class="mb-4 rounded-lg"
              >
                <span class="font-weight-medium text-body-2">
                  Seleccione un neumático del catálogo superior y haga clic en
                  una ranura para comparar. Haga clic en un neumático asignado
                  para quitarlo de la tabla.
                </span>
              </v-alert>

              <!-- Panel de Parámetros y Columnas Visibles -->
              <div class="parametros-filtros-box pa-3 rounded-lg mb-4">
                <div class="d-flex align-center mb-2">
                  <v-icon x-small color="grey darken-2" class="mr-1"
                    >mdi-view-column-outline</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold grey--text text--darken-3 text-uppercase"
                  >
                    Columnas y Parámetros Visibles
                  </span>
                </div>
                <v-row dense class="px-1">
                  <div
                    v-for="(item, index) in filtros"
                    :key="index"
                    class="col-lg-3 col-sm-6 col-md-6 col-xs-12 py-1"
                  >
                    <v-checkbox
                      class="ma-0 pa-0 custom-checkbox-filter"
                      dense
                      hide-details
                      @click="cargarEncabezados"
                      v-model="item.valor"
                      :label="item.descripcion"
                    ></v-checkbox>
                  </div>
                </v-row>
              </div>

              <!-- Indicador de desplazamiento horizontal en móvil -->
              <div
                class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-1"
              >
                <v-icon x-small color="primary" class="mr-1"
                  >mdi-gesture-swipe-horizontal</v-icon
                >
                <span>Desliza horizontalmente para comparar todos los neumáticos</span>
              </div>

              <!-- Tabla Comparativa -->
              <div class="comparative-table-wrapper">
                <table
                  class="tabla-comparativa-moderna"
                  style="width: 100%"
                  id="table"
                >
                  <tbody>
                    <tr
                      v-for="(item, index) in encabezados"
                      :key="index"
                      v-if="item.visible == true"
                      :class="[
                        item.name === 'num_serie' ? 'fila-header-slots' : '',
                        item.name === 'kilometraje_proyectado'
                          ? 'fila-proyectado'
                          : '',
                        item.name === 'costo_kmhr_acumulado'
                          ? 'fila-acumulado'
                          : '',
                      ]"
                    >
                      <td
                        class="th-parametro"
                        :class="{
                          'th-parametro-header': item.name === 'num_serie',
                          'th-parametro-destacado':
                            item.name === 'costo_kmhr_acumulado' ||
                            item.name === 'kilometraje_proyectado',
                        }"
                      >
                        <div class="d-flex align-center">
                          <v-icon
                            small
                            class="mr-2"
                            :color="getIconColor(item.name)"
                          >
                            {{ getIconForParametro(item.name) }}
                          </v-icon>
                          <span class="parametro-titulo">{{
                            getDescripcionEncabezado(item)
                          }}</span>
                        </div>
                      </td>
                      <td
                        :class="[
                          item.clase,
                          'td-comparativa',
                          item2.id ? 'col-con-dato' : 'col-vacia',
                          item.name === 'num_serie' ? 'td-slot-header' : '',
                        ]"
                        v-for="(item2, index2) in NeumaticosAComparar"
                        :key="index2"
                      >
                        <template v-if="item.name == 'num_serie'">
                          <div
                            class="neumatico-slot-card"
                            :class="{
                              'slot-asignado': item2.id,
                              'slot-vacio': !item2.id,
                              'slot-seleccionable':
                                neumaticoSeleccionado && !item2.id,
                            }"
                            @click="validacionNeumaticos(item2, index2)"
                            :title="
                              item2.id
                                ? 'Clic para quitar neumático de la comparación'
                                : neumaticoSeleccionado
                                ? 'Clic para asignar neumático seleccionado'
                                : 'Ranura disponible'
                            "
                          >
                            <div class="slot-badge-number">
                              {{ index2 + 1 }}
                            </div>
                            <div class="neumatico-img-container">
                              <img
                                :src="imagen"
                                alt="neumatico"
                                :class="item2.clase"
                                class="neumatico-img"
                              />
                              <v-btn
                                v-if="item2.id"
                                icon
                                x-small
                                color="error"
                                class="btn-quitar-slot"
                                title="Quitar neumático"
                              >
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                            </div>
                            <div class="slot-info-box mt-1">
                              <span
                                v-if="item2.num_serie"
                                class="font-weight-bold grey--text text--darken-3 slot-serie-text"
                              >
                                {{ item2.num_serie }}
                              </span>
                              <span
                                v-else
                                class="text-caption grey--text text--darken-1 font-italic slot-empty-text"
                              >
                                {{
                                  neumaticoSeleccionado
                                    ? "+ Asignar aquí"
                                    : "Neumático " + (index2 + 1)
                                }}
                              </span>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-if="
                              item2.id &&
                              item2[item.name] !== undefined &&
                              item2[item.name] !== null &&
                              item2[item.name] !== ''
                            "
                            class="valor-celda-wrapper"
                          >
                            <span
                              :class="
                                getValorClass(item.name, item2[item.name])
                              "
                            >
                              {{ item2[item.name] }}
                            </span>
                          </div>
                          <span
                            v-else-if="item2.id"
                            class="grey--text text--lighten-1 font-weight-light"
                            >-</span
                          >
                          <span
                            v-else
                            class="grey--text text--lighten-3 font-weight-light"
                            >-</span
                          >
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-card>

          <!-- Botón Exportar al fondo -->
          <v-row v-if="mostrarComponente == true" class="mt-4">
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                color="success"
                height="40"
                class="filter-action-btn font-weight-bold px-4"
                :loading="loadingExcel"
                :disabled="!NeumaticosAComparar.some((e) => e.id)"
                @click="exportarAExcel"
              >
                <v-icon left small>mdi-file-excel</v-icon>
                Exportar Excel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import description from "../../components/instalacionneumaticos/description.vue";
import Neumaticos from "../../components/NeumaticoHorizontalTable.vue";
// import axios from "axios";

import { axios2 as axios } from "@/interceptor/useApi";
import global from "@/global";

export default {
  components: {
    description,
    Neumaticos,
  },
  data() {
    return {
      global,
      dato_seleccionado: [],
      Item: {},
      Neumaticos: [],
      Cabecera: [
        {
          text: "",
          value: "num_serie",
          align: "center",
          width: "80",
        },
      ],
      tiposCosto: [
        {
          value: "K",
          text: "Kilómetros",
        },
        {
          value: "H",
          text: "Horas",
        },
      ],
      ejes: [
        {
          value: 1,
          text: "Direccional",
        },
        {
          value: 2,
          text: "Tracción",
        },
        {
          value: 3,
          text: "Eje libre",
        },
      ],
      modelosPorMarca: [],
      filtros: [
        {
          descripcion: "Nuevo",
          valor: false,
        },
        {
          descripcion: "1 Reencauche",
          valor: false,
        },
        {
          descripcion: "2 Reencauches",
          valor: false,
        },
        {
          descripcion: "3 Reencauches",
          valor: false,
        },
        {
          descripcion: "4 Reencauches",
          valor: false,
        },
        {
          descripcion: "5 Reencauches",
          valor: false,
        },
        {
          descripcion: "6 Reencauches",
          valor: false,
        },
        {
          descripcion: "Más de 6 Reencauches",
          valor: false,
        },
        {
          descripcion: "Ver costos reparación",
          valor: false,
        },
        {
          descripcion: "Ver costos",
          valor: false,
        },
        {
          descripcion: "Ver recorrido",
          valor: false,
        },
      ],
      reencauches: [
        {
          value: "N",
          text: "Nuevo",
        },
        {
          value: 1,
          text: "1 reencauche",
        },
        {
          value: 2,
          text: "2 reencauche",
        },
        {
          value: 3,
          text: "3 reencauche",
        },
        {
          value: 4,
          text: "4 reencauche",
        },
        {
          value: 5,
          text: "5 reencauche",
        },
        {
          value: 6,
          text: "6 reencauche",
        },
        {
          value: "R",
          text: "Más de 6 reencauche",
        },
      ],
      encabezados: [],
      arrayitems: [
        {
          descripcion: "serie",
          name: "num_serie",
          visible: true,
          clase: "border texto-cen pa-2",
          grupo: "",
        },
        {
          descripcion: "tipo costo",
          name: "descripcion_tipocosto",
          visible: true,
          clase: "border texto-cen pa-2",
          grupo: "",
        },
        {
          descripcion: "Marca",
          name: "marca",
          visible: true,
          clase: "border texto-cen pa-2",
          grupo: "",
        },
        {
          descripcion: "Modelo",
          name: "modelo",
          visible: true,
          clase: "border texto-cen pa-2",
          grupo: "",
        },
        {
          descripcion: "Medida",
          name: "medida",
          visible: true,
          clase: "border texto-cen pa-2",
          grupo: "",
        },
        {
          descripcion: "Costo reparación Nuevo",
          name: "costo_neumatico_nuevo_reparacion",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo_reparacion",
          check: "nuevo",
        },
        {
          descripcion: "Costo Nuevo",
          name: "costo_neumatico_nuevo",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo",
          check: "nuevo",
        },
        {
          descripcion: "Km|Hr Nuevo",
          name: "recorrido_neumatico_nuevo",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "kilometros",
          check: "nuevo",
        },
        {
          descripcion: "Costo x Km|Hr Nuevo",
          name: "costo_kmhr_nuevo",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "nuevo",
          check: "",
        },
        {
          descripcion: "Costo reparación R1",
          name: "costo_neumatico_reparacion_r1",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo_reparacion",
          check: "r1",
        },
        {
          descripcion: "Costo R1",
          name: "costo_neumatico_r1",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo",
          check: "r1",
        },
        {
          descripcion: "Km|Hr R1",
          name: "recorrido_neumatico_r1",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "kilometros",
          check: "r1",
        },
        {
          descripcion: "Costo x Km|Hr R1",
          name: "costo_kmhr_r1",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "r1",
          check: "",
        },
        {
          descripcion: "Costo reparación R2",
          name: "costo_neumatico_reparacion_r2",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo_reparacion",
          check: "r2",
        },
        {
          descripcion: "Costo R2",
          name: "costo_neumatico_r2",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo",
          check: "r2",
        },
        {
          descripcion: "Km|Hr R2",
          name: "recorrido_neumatico_r2",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "kilometros",
          check: "r2",
        },
        {
          descripcion: "Costo x Km|Hr R2",
          name: "costo_kmhr_r2",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "r2",
          check: "",
        },
        {
          descripcion: "Costo reparación R3",
          name: "costo_neumatico_reparacion_r3",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo_reparacion",
          check: "r3",
        },
        {
          descripcion: "Costo R3",
          name: "costo_neumatico_r3",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo",
          check: "r3",
        },
        {
          descripcion: "Km|Hr R3",
          name: "recorrido_neumatico_r3",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "kilometros",
          check: "r3",
        },
        {
          descripcion: "Costo x Km|Hr R3",
          name: "costo_kmhr_r3",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "r3",
          check: "",
        },
        {
          descripcion: "Costo reparación R4",
          name: "costo_neumatico_reparacion_r4",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo_reparacion",
          check: "r4",
        },
        {
          descripcion: "Costo R4",
          name: "costo_neumatico_r4",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo",
          check: "r4",
        },
        {
          descripcion: "Km|Hr R4",
          name: "recorrido_neumatico_r4",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "kilometros",
          check: "r4",
        },
        {
          descripcion: "Costo x Km|Hr R4",
          name: "costo_kmhr_r4",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "r4",
          check: "",
        },
        {
          descripcion: "Costo reparación R5",
          name: "costo_neumatico_reparacion_r5",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo_reparacion",
          check: "r5",
        },
        {
          descripcion: "Costo R5",
          name: "costo_neumatico_r5",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo",
          check: "r5",
        },
        {
          descripcion: "Km|Hr R5",
          name: "recorrido_neumatico_r5",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "kilometros",
          check: "r5",
        },
        {
          descripcion: "Costo x Km|Hr R5",
          name: "costo_kmhr_r5",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "r5",
          check: "",
        },
        {
          descripcion: "Costo reparación R6",
          name: "costo_neumatico_reparacion_r6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo_reparacion",
          check: "r6",
        },
        {
          descripcion: "Costo R6",
          name: "costo_neumatico_r6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "costo",
          check: "r6",
        },
        {
          descripcion: "Km|Hr R6",
          name: "recorrido_neumatico_r6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "kilometros",
          check: "r6",
        },
        {
          descripcion: "Costo x Km|Hr R6",
          name: "costo_kmhr_r6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-1",
          grupo: "r6",
          check: "",
        },
        {
          descripcion: "Costo reparación de más de 6 R",
          name: "costo_reenc_reparacion_mayores_6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo_reparacion",
          check: "m6",
        },
        {
          descripcion: "Costo de más de 6 R",
          name: "costo_reenc_mayores_6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "costo",
          check: "m6",
        },
        {
          descripcion: "Km|Hr de más de 6 R",
          name: "recorrido_reenc_mayores_6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "kilometros",
          check: "m6",
        },
        {
          descripcion: "Costo x Km|Hr de más de 6 R",
          name: "costo_kmhr_reenc_mayores_6",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-2",
          grupo: "m6",
          check: "",
        },
        {
          descripcion: "Costo acumulado de reparación",
          name: "costo_acumulado_reparacion",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-3",
          grupo: "costo_reparacion",
          check: "costo_reparacion",
        },
        {
          descripcion: "Costo acumulado",
          name: "costo_acumulado",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-3",
          grupo: "costo",
          check: "costo",
        },
        {
          descripcion: "Km|Hr Acumulado",
          name: "recorrido_kmhr_acumulado",
          visible: false,
          clase: "border texto-cen pa-2 bg-celda-3",
          grupo: "kilometros",
          check: "kilometros",
        },
        {
          descripcion: "Costo x Km|Hr Acumulado",
          name: "costo_kmhr_acumulado",
          visible: true,
          clase: "border texto-cen pa-2 bg-celda-3",
          grupo: "",
          check: "",
        },
        {
          descripcion: "Km|Hr Proyectados (Km|Hr x mm)",
          name: "kilometraje_proyectado",
          visible: true,
          clase: "border texto-cen pa-2 bg-celda-4",
          grupo: "",
          check: "",
        },
      ],
      NeumaticosAComparar: [
        {
          id: "",
          pos: 0,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 1,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 2,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          pos: 3,
          id: "",
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          pos: 4,
          id: "",
          asignado: false,
          clase: "imagen-neumatico1",
        },
      ],
      opcionesPagina: [
        { value: 6, text: 6 },
        { value: 12, text: 12 },
        { value: 18, text: 18 },
        { value: "", text: "All" },
      ],
      mostrarComponente: false,
      neumaticoSeleccionado: null,
      imagen: "images/llanta.png",
      loader: false,
      VerTooltip: true,
      Neumaticos: [],

      seleccionados: [],
      neumaticoseleccionadoacomparar: [],
      ItemTotal: 0,

      data: [],
      per_page: 6,
      page: 1,
      from: 1,
      to: 6,
      sortBy: "id",
      sortDirection: "desc",
      loadingExcel: false,
    };
  },
  computed: {
    ...mapState("reportes", ["Marcas", "Modelos", "Medidas"]),
    ...mapState("neumatico", ["Items"]),

    cantidadNeumaticosAsignados() {
      if (!this.NeumaticosAComparar) return 0;
      return this.NeumaticosAComparar.filter((e) => e && e.id).length;
    },
  },
  methods: {
    ...mapActions("reportes", [
      "DatosMarcasModelosMedidas",
      "DatosReporteComparativoConfiguracion",
    ]),
    ...mapActions("neumatico", ["cargarNeumaticos", "filtrarNeumaticos"]),

    getDescripcionEncabezado(item) {
      const tipocosto = this.Item.tipocosto;
      let desc = item.descripcion || "";
      if (tipocosto == 1 || tipocosto == "K") {
        desc = desc.replace(/Km\|Hr/g, "Km").replace(/Km\/Hr/g, "Km");
      } else if (tipocosto == 2 || tipocosto == "H") {
        desc = desc
          .replace(/Km\|Hr Proyectados/g, "Hr Proyectadas")
          .replace(/Km\|Hr/g, "Hr")
          .replace(/Km\/Hr/g, "Hr");
      } else {
        desc = desc.replace(/Km\|Hr/g, "Km/Hr");
      }
      return desc;
    },

    getIconForParametro(name) {
      if (name === "num_serie") return "mdi-numeric";
      if (name === "descripcion_tipocosto") return "mdi-currency-usd";
      if (name === "marca") return "mdi-tag-outline";
      if (name === "modelo") return "mdi-tag";
      if (name === "medida") return "mdi-ruler";
      if (name.includes("reparacion")) return "mdi-wrench-outline";
      if (name.includes("costo_kmhr") || name === "costo_kmhr_acumulado")
        return "mdi-chart-line";
      if (name.includes("kilometraje_proyectado")) return "mdi-target";
      if (name.includes("costo")) return "mdi-cash";
      if (name.includes("recorrido") || name.includes("kmhr"))
        return "mdi-speedometer";
      return "mdi-circle-small";
    },

    getIconColor(name) {
      if (name === "kilometraje_proyectado") return "success";
      if (name === "costo_kmhr_acumulado") return "primary";
      if (name.includes("costo")) return "amber darken-2";
      if (name.includes("reparacion")) return "orange darken-2";
      return "grey lighten-2";
    },

    getValorClass(name, value) {
      if (name === "costo_kmhr_acumulado") {
        return "valor-destacado-acumulado";
      }
      if (name === "kilometraje_proyectado") {
        return "valor-destacado-proyectado";
      }
      if (name.includes("costo_kmhr")) {
        return "font-weight-bold blue--text text--darken-3";
      }
      if (name.includes("costo")) {
        return "font-weight-medium grey--text text--darken-3";
      }
      return "grey--text text--darken-3";
    },

    onMarca: function () {
      this.modelosPorMarca = [];
      this.Modelos.forEach((element) => {
        if (element.id_marca == this.Item.marca) {
          this.modelosPorMarca.push(element);
        }
      });
      this.DatosMarcasModelosMedidas(this.Item);
    },
    /*
    onBusqueda: function () {
      if (this.search == "") {
        this.cargarComponenteNeumaticos();
      } else {
        let aux = [];
        this.Neumaticos.forEach((element) => {
          element.forEach((element1) => {
            let serie = element1.num_serie;
            if (serie.includes(this.search) == true) {
              aux.push(element1);
            }
          });
        });
        this.paginacion(aux.length, aux);
      }
    },
    */

    seleccionarNeumatico: function (item) {
      if (!item) {
        this.neumaticoSeleccionado = null;
        this.dato_seleccionado = [];
        return;
      }
      const isSame =
        this.neumaticoSeleccionado &&
        (this.neumaticoSeleccionado === item ||
          (this.neumaticoSeleccionado.id != null &&
            item.id != null &&
            this.neumaticoSeleccionado.id !== "" &&
            String(this.neumaticoSeleccionado.id) === String(item.id)) ||
          (this.neumaticoSeleccionado.num_serie &&
            item.num_serie &&
            this.neumaticoSeleccionado.num_serie === item.num_serie));

      if (isSame) {
        this.neumaticoSeleccionado = null;
        this.dato_seleccionado = [];
      } else {
        this.neumaticoSeleccionado = item;
        this.dato_seleccionado = [item];
      }
    },

    cargarDatos: async function () {
      this.neumaticoSeleccionado = null;
      this.dato_seleccionado = [];
      this.seleccionados = [];
      this.neumaticoseleccionadoacomparar = [];
      this.NeumaticosAComparar = [
        {
          id: "",
          pos: 0,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 1,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 2,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 3,
          asignado: false,
          clase: "imagen-neumatico1",
        },
        {
          id: "",
          pos: 4,
          asignado: false,
          clase: "imagen-neumatico1",
        },
      ];
      this.FiltroNeumaticos({
        page: 1,
        per_page: 6,
        search: "",
        sortBy: "id",
        sortDirection: "desc",
      });
    },

    FiltroNeumaticos({
      page = 1,
      per_page = 6,
      search = "",
      sortBy = "id",
      sortDirection = "desc",
    } = {}) {
      this.loader = true;
      this.filtrarNeumaticos([
        { page, per_page, num_serie: search, sortBy, sortDirection },
        this.Item,
      ])
        .then(() => {
          let lista = [];
          if (Array.isArray(this.Items)) {
            lista = this.Items;
            this.ItemTotal = this.Items.length;
            this.page = page;
            this.per_page = per_page;
            this.from = lista.length > 0 ? (page - 1) * per_page + 1 : 0;
            this.to = Math.min(page * per_page, lista.length);
          } else if (this.Items && Array.isArray(this.Items.data)) {
            lista = this.Items.data;
            this.ItemTotal =
              this.Items.total !== undefined ? this.Items.total : lista.length;
            this.page = this.Items.current_page || page;
            this.per_page = this.Items.per_page || per_page;
            this.from = this.Items.from || 1;
            this.to = this.Items.to || lista.length;
          } else {
            lista = [];
            this.ItemTotal = 0;
            this.from = 0;
            this.to = 0;
          }

          lista.forEach((element) => {
            if (element) {
              element.descripcion = element.num_serie || element.descripcion;
            }
          });

          this.Neumaticos = lista;
          this.data = lista;
          this.loader = false;
          this.mostrarComponente = true;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error("Error al filtrar neumáticos:", error);
          this.loader = false;
          this.data = [];
          this.Neumaticos = [];
        });
    },
    validacionNeumaticos: async function (item, index) {
      let neumaticorepetido = false;
      if (!item.asignado) {
        if (this.neumaticoSeleccionado != null) {
          this.NeumaticosAComparar.forEach((element) => {
            if (
              (element.num_serie &&
                element.num_serie === this.neumaticoSeleccionado.num_serie) ||
              (element.id &&
                String(element.id) === String(this.neumaticoSeleccionado.id))
            ) {
              neumaticorepetido = true;
            }
          });
          if (!neumaticorepetido) {
            // consultar a neumatico comparación
            let neumatico = await this.DatosReporteComparativoConfiguracion({
              id: this.neumaticoSeleccionado.id,
            });
            if (neumatico) {
              neumatico.pos = index;
              neumatico.asignado = true;
              neumatico.clase = "imagen-neumatico2";
              this.$set(this.NeumaticosAComparar, index, neumatico);
              this.neumaticoseleccionadoacomparar[index] =
                this.neumaticoSeleccionado;
              this.seleccionados = [
                ...this.seleccionados,
                this.neumaticoSeleccionado,
              ];
              this.neumaticoSeleccionado = null;
              this.dato_seleccionado = [];
            }
          }
        }
      } else {
        const itemRemovido = this.neumaticoseleccionadoacomparar[index];
        this.neumaticoseleccionadoacomparar[index] = null;
        if (itemRemovido) {
          this.seleccionados = this.seleccionados.filter((s) => {
            if (!s) return false;
            if (s === itemRemovido) return false;
            if (
              s.id != null &&
              itemRemovido.id != null &&
              String(s.id) === String(itemRemovido.id)
            )
              return false;
            if (
              s.num_serie &&
              itemRemovido.num_serie &&
              s.num_serie === itemRemovido.num_serie
            )
              return false;
            return true;
          });
        }
        this.$set(this.NeumaticosAComparar, index, {
          pos: index,
          id: "",
          asignado: false,
          clase: "imagen-neumatico1",
        });

        if (this.neumaticoSeleccionado != null) {
          let neumaticorepetido2 = false;
          this.NeumaticosAComparar.forEach((element) => {
            if (
              (element.num_serie &&
                element.num_serie === this.neumaticoSeleccionado.num_serie) ||
              (element.id &&
                String(element.id) === String(this.neumaticoSeleccionado.id))
            ) {
              neumaticorepetido2 = true;
            }
          });
          if (!neumaticorepetido2) {
            let neumatico = await this.DatosReporteComparativoConfiguracion({
              id: this.neumaticoSeleccionado.id,
            });
            if (neumatico) {
              neumatico.pos = index;
              neumatico.asignado = true;
              neumatico.clase = "imagen-neumatico2";
              this.$set(this.NeumaticosAComparar, index, neumatico);
              this.neumaticoseleccionadoacomparar[index] =
                this.neumaticoSeleccionado;
              this.seleccionados = [
                ...this.seleccionados,
                this.neumaticoSeleccionado,
              ];
              this.neumaticoSeleccionado = null;
              this.dato_seleccionado = [];
            }
          }
        }
      }
      this.$forceUpdate();
    },

    mostrarCeldas: function (element) {
      if (this.filtros[8].valor == true) {
        if (element.grupo == "costo_reparacion") {
          element.visible = true;
        }
      }
      if (this.filtros[9].valor == true) {
        if (element.grupo == "costo") {
          element.visible = true;
        }
      }
      if (this.filtros[10].valor == true) {
        if (element.grupo == "kilometros") {
          element.visible = true;
        }
      }
    },

    cargarEncabezados: function () {
      this.encabezados = [];
      this.arrayitems.forEach((element) => {
        if (this.filtros[0].valor == true) {
          if (element.grupo == "nuevo") {
            element.visible = true;
          } else if (element.check == "nuevo") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "nuevo") {
            element.visible = false;
          }
        }

        if (this.filtros[1].valor == true) {
          if (element.grupo == "r1") {
            element.visible = true;
          } else if (element.check == "r1") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r1") {
            element.visible = false;
          }
        }

        if (this.filtros[2].valor == true) {
          if (element.grupo == "r2") {
            element.visible = true;
          } else if (element.check == "r2") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r2") {
            element.visible = false;
          }
        }

        if (this.filtros[3].valor == true) {
          if (element.grupo == "r3") {
            element.visible = true;
          } else if (element.check == "r3") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r3") {
            element.visible = false;
          }
        }

        if (this.filtros[4].valor == true) {
          if (element.grupo == "r4") {
            element.visible = true;
          } else if (element.check == "r4") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r4") {
            element.visible = false;
          }
        }

        if (this.filtros[5].valor == true) {
          if (element.grupo == "r5") {
            element.visible = true;
          } else if (element.check == "r5") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r5") {
            element.visible = false;
          }
        }

        if (this.filtros[6].valor == true) {
          if (element.grupo == "r6") {
            element.visible = true;
          } else if (element.check == "r6") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "r6") {
            element.visible = false;
          }
        }

        if (this.filtros[7].valor == true) {
          if (element.grupo == "m6") {
            element.visible = true;
          } else if (element.check == "m6") {
            this.mostrarCeldas(element);
          }
        } else {
          if (element.grupo == "m6") {
            element.visible = false;
          }
        }

        if (this.filtros[8].valor == true) {
          if (
            element.grupo == "costo_reparacion" &&
            element.check == "costo_reparacion"
          ) {
            element.visible = true;
          }
        } else {
          if (element.grupo == "costo_reparacion") {
            element.visible = false;
          }
        }

        if (this.filtros[9].valor == true) {
          if (element.grupo == "costo" && element.check == "costo") {
            element.visible = true;
          }
        } else {
          if (element.grupo == "costo") {
            element.visible = false;
          }
        }

        if (this.filtros[10].valor == true) {
          if (element.grupo == "kilometros" && element.check == "kilometros") {
            element.visible = true;
          }
        } else {
          if (element.grupo == "kilometros") {
            element.visible = false;
          }
        }

        if (element.visible == true) {
          this.encabezados.push(element);
        }
      });
    },
    /*
    mostrarPagina: async function () {
      this.datosPaginados = [];
      this.datosPaginados.push(this.Neumaticos[this.pagina_actual - 1]);
      this.$forceUpdate();
    },

    paginacion: function (total, array) {
      this.Neumaticos = [];
      this.datosPaginados = [];
      let items_por_td = this.porPagina != "" ? this.porPagina : total;
      this.pagina_actual = 1;
      this.paginas = Math.ceil(total / items_por_td);
      var index = 0;
      for (let i = 0; i < this.paginas; i++) {
        var temporal = [];
        for (let j = 0; j < items_por_td && index < total; j++, index++) {
          temporal.push(array[index]);
        }
        this.Neumaticos.push(temporal);
      }
      this.datosPaginados.push(this.Neumaticos[this.pagina_actual - 1]);
    },
    */
    _json_to_query_string: function (json) {
      json = Object.keys(json).map((item) => {
        return item + "=" + json[item] || "";
      });
      return json.join("&");
    },

    exportarAExcel: async function () {
      this.loadingExcel = true;
      try {
        // Filtrar los IDs válidos
        let array_id_neumaticos = [];
        this.NeumaticosAComparar.forEach((element) => {
          if (element.id != "") {
            array_id_neumaticos.push(element.id);
          }
        });
        const url =
          axios.defaults.baseURL +
          "excel/reportecomparativoneumaticos?" +
          this._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            array_id_neumaticos: array_id_neumaticos,
          });

        const response = await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        });

        // Extraer el nombre del archivo del encabezado
        let nombre_archivo = "reporte.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
          const asciiMatch = disposition.match(/filename="?([^;\n"]+)"?/i);

          if (utf8Match && utf8Match[1]) {
            nombre_archivo = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch && asciiMatch[1]) {
            nombre_archivo = asciiMatch[1];
          }
        }

        // Verificar si el archivo es HTML (error)
        if (response.data.type === "text/html") {
          const text = await response.data.text();
          const res = JSON.parse(text);
          if (!res.exito) {
            alert(res.mensaje || "Ocurrió un error al generar el archivo.");
            return;
          }
        } else {
          // Descargar el archivo
          const blob = new Blob([response.data]);
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", nombre_archivo);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        this.errorMessage = error.response?.data || "Error inesperado";
        console.error("Error al exportar a Excel:", error);
      } finally {
        this.loadingExcel = false;
      }
    },
    /*
    titulo: function (estado) {
      if (estado == 1) {
        return "Listo para instalar";
      } else if (estado == 2) {
        return "En reparación";
      } else if (estado == 3) {
        return "Instalado";
      } else if (estado == 4) {
        return "En reencauche";
      } else if (estado == 5) {
        return "Listo para instalar";
      } else {
        return "";
      }
    },

    subtitulo: function (estado) {
      if (estado == 1) {
        return "";
      } else if (estado == 2) {
        return "Registre el costo de reparación";
      } else if (estado == 3) {
        return "";
      } else if (estado == 4) {
        return "Registre el costo de reencauche";
      } else {
        return "";
      }
    },
    */

    getNeumaticos({
      page = 1,
      per_page = 6,
      search = "",
      sortBy = "id",
      sortDirection = "desc",
    }) {
      this.loader = true;
      this.cargarNeumaticos({
        page,
        per_page,
        num_serie: search,
        sortBy,
        sortDirection,
      })
        .then(() => {
          let lista = [];
          if (Array.isArray(this.Items)) {
            lista = this.Items;
            this.ItemTotal = this.Items.length;
            this.page = page;
            this.per_page = per_page;
            this.from = lista.length > 0 ? (page - 1) * per_page + 1 : 0;
            this.to = Math.min(page * per_page, lista.length);
          } else if (this.Items && Array.isArray(this.Items.data)) {
            lista = this.Items.data;
            this.ItemTotal = this.Items.total || lista.length;
            this.page = this.Items.current_page || page;
            this.per_page = this.Items.per_page || per_page;
            this.from = this.Items.from || 1;
            this.to = this.Items.to || lista.length;
          }

          lista.forEach((element) => {
            if (element) {
              element.descripcion = element.num_serie || element.descripcion;
            }
          });

          this.data = lista;
          this.Neumaticos = lista;
          this.loader = false;
          this.mostrarComponente = true;
        })
        .catch((error) => {
          console.error("Error al cargar neumáticos:", error);
          this.loader = false;
          this.data = [];
        });
    },
  },
  mounted: async function () {
    this.DatosMarcasModelosMedidas();
    //  this.getNeumaticos({page: 1, per_page: 6, search: '', sortBy: 'id', sortDirection: 'desc'});
    // this.data.forEach((element) => {
    //   element.descripcion = element.num_serie;
    // });
    //let total = this.Items.length;
    //this.paginacion(total, this.Items);
    this.cargarEncabezados();
  },
};
</script>

<style scoped>
.comparativo-configuracion-wrapper {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.back-btn {
  font-weight: bold;
  border-radius: 8px !important;
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Card de Filtros y Subtítulos */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background: #ffffff;
  transition: box-shadow 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* Campos de Formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.filter-action-btn {
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 0.875rem !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

/* Caja de Parámetros y Filtros */
.parametros-filtros-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.custom-checkbox-filter ::v-deep label {
  font-size: 11.5px !important;
  color: #334155 !important;
  font-weight: 500;
}

.comparative-table-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  -webkit-overflow-scrolling: touch;
}

.comparative-table-wrapper::-webkit-scrollbar {
  height: 6px;
}

.comparative-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.comparative-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.comparative-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.tabla-comparativa-moderna {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 900px;
}

.th-parametro {
  background-color: #545554 !important;
  color: #ffffff !important;
  font-weight: 600;
  font-size: 11.5px;
  text-align: left;
  vertical-align: middle;
  padding: 8px 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  width: 220px;
  min-width: 200px;
  position: sticky;
  left: 0;
  z-index: 3;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.th-parametro-header {
  background-color: #424242 !important;
  vertical-align: middle;
}

.th-parametro-destacado {
  background-color: #3f403f !important;
  font-weight: 700;
}

.parametro-titulo {
  letter-spacing: 0.2px;
  line-height: 1.3;
}

.td-comparativa {
  padding: 8px 12px;
  text-align: center;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
  min-width: 150px;
  width: 15.6%;
  transition: background-color 0.15s ease;
}

.td-comparativa:last-child {
  border-right: none;
}

.td-slot-header {
  padding: 12px 8px;
  background-color: #f8fafc !important;
}

.neumatico-slot-card {
  border-radius: 12px;
  padding: 10px 8px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.25s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 115px;
}

.neumatico-slot-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.slot-vacio {
  border: 1.5px dashed #cbd5e1;
  background: #f8fafc;
}

.slot-vacio:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
}

.slot-seleccionable {
  border: 1.5px dashed #3b82f6 !important;
  background: #eff6ff !important;
}

.slot-asignado {
  border: 1.5px solid #bfdbfe;
  background: #ffffff;
}

.slot-asignado:hover {
  border-color: #ef4444;
  background: #fef2f2;
}

.slot-badge-number {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
  background: #e2e8f0;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
}

.neumatico-img-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.neumatico-img {
  max-width: 55px;
  max-height: 55px;
  object-fit: contain;
  transition: transform 0.2s ease;
}

.neumatico-slot-card:hover .neumatico-img {
  transform: scale(1.05);
}

.btn-quitar-slot {
  position: absolute;
  top: -8px;
  right: -12px;
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.slot-serie-text {
  font-size: 12px;
  letter-spacing: 0.3px;
}

.slot-empty-text {
  font-size: 11px;
}

.valor-destacado-acumulado {
  color: #1d4ed8 !important;
  font-weight: 700 !important;
  font-size: 12px !important;
}

.valor-destacado-proyectado {
  color: #047857 !important;
  font-weight: 700 !important;
  font-size: 12px !important;
}

.fila-proyectado td:not(.th-parametro) {
  background-color: #f0fdf4 !important;
}

.fila-acumulado td:not(.th-parametro) {
  background-color: #f1f5f9 !important;
}

.bg-celda-1 {
  background: #f8fafc;
}

.bg-celda-2 {
  background: #ffffff;
}

.bg-celda-3 {
  background: #f1f5f9;
}

.bg-celda-4 {
  background: #f0fdf4;
}

.imagen-neumatico1 {
  width: 55px;
  opacity: 0.45;
  filter: grayscale(100%);
}

.imagen-neumatico2 {
  width: 55px;
  opacity: 1;
}

.tabla-comparativa-moderna
  tbody
  tr:hover:not(.fila-header-slots)
  td:not(.th-parametro) {
  background-color: #f8fafc;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }

  /* Tabla Comparativa en Celular */
  .tabla-comparativa-moderna {
    min-width: 820px;
  }

  .th-parametro {
    width: 165px;
    min-width: 165px;
    padding: 8px 10px;
    font-size: 10.5px;
  }

  .parametro-titulo {
    font-size: 10.5px;
  }

  .td-comparativa {
    min-width: 130px;
    padding: 6px 8px;
    font-size: 10.5px;
  }

  .neumatico-slot-card {
    min-height: 105px;
    padding: 8px 6px;
  }

  .neumatico-img {
    max-width: 46px;
    max-height: 46px;
  }

  .slot-serie-text {
    font-size: 11px;
  }
}
</style>
